
import { enhanceAllPythonModulesWithQuizzes } from './quizEnhancer';
import { PYTHON_TRACKS } from './tracks';
import { PythonCourse } from './types';

// Enhance all Python courses with comprehensive quiz content
const enhancedPythonCourses = PYTHON_TRACKS.map(course => ({
  ...course,
  modules: enhanceAllPythonModulesWithQuizzes(course.modules)
}));

export const PYTHON_COURSES: PythonCourse[] = enhancedPythonCourses;

// Re-export everything from tracks for backward compatibility
export * from './tracks';
export * from './types';
